<template>
    <div class="editor-property-panel">
        <div class="editor-property-panel-header" @click="expanded = !expanded">
            <h3>{{ title }}</h3>
            <button class="btn-expand">
                <img v-if="!expanded" src="@/assets/icons/allow-down.svg">
                <img v-else src="@/assets/icons/allow-up.svg">
            </button>
        </div>
        <div v-if="expanded" class="editor-property-panel-body">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-property-panel",
    components: {

    },
    props: {
        title: {
            type: String,
            default: "Panel",
            required: true,
        },
        expandedInit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            expanded: false,
        };
    },
    watch: {
        expandedInit: function (val) {
            this.expanded = val;
        },
    },
    mounted() {
        let vm = this;
        vm.expanded = vm.expandedInit;
    },
    methods: {
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.editor-property-panel {
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    margin-bottom: 5px;

    .editor-property-panel-header {
        padding: 10px 5px;
        border-bottom: 1px solid #e9e9e9;
        background-color: #F5F5F5;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;

        h3 {
            margin: 0;
            font-size: 12px;
        }

        .btn-expand {
            img {
                width: 13px;
                height: 13px;
            }
        }
    }

    .editor-property-panel-body {
        background-color: #F5F5F5;
        padding: 5px 5px;
        min-height: 40px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}
</style>